import { StandardTabs } from '@dreryk/react-components';

import { translationKeys } from '../translations';

import { PredefinedPatientGroupsTable } from './predefined/PredefinedPatientGroupsTable';
import { CustomPatientGroupsTable } from './custom/CustomPatientGroupsTable';

export const PatientGroupsTabs = (): JSX.Element => {
   return (
      <StandardTabs testId={'patientGroups'} initialActiveTabId={'custom'}>
         <StandardTabs.Tab id={'custom'} testId={'custom'} label={translationKeys.customGroups}>
            <CustomPatientGroupsTable />
         </StandardTabs.Tab>

         <StandardTabs.Tab id={'predefined'} testId={'predefined'} label={translationKeys.predefinedGroups}>
            <PredefinedPatientGroupsTable />
         </StandardTabs.Tab>
      </StandardTabs>
   );
};
